import { StepContext, StepProps } from "../../../types";

export const Preview = <T extends StepContext>({ context }: StepProps<T>) => {
    return (
        <div>
            Preview Component:
            <pre>{JSON.stringify(context, null, 2)}</pre>
        </div>
    );
};
